import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"
import { isLoading } from "helpers/data-statuses"
import Loading from "components/loading"
import { useAccountAlias } from "resources/account"

// Route gate for AI terms acceptance, which lives outside enabledFeatures
// (global.data.aiTermsAndConditions) so withFeatureGate cannot cover it. Holds render until the
// permission resource resolves, so this T&C-gated surface never flashes its shell before acceptance
// is known (and an already-accepted account is never flash-redirected on a cold load / deep link).
// Once resolved, only an accepted account proceeds; a declined or errored result redirects to /home.
export default function withAiTermsGate(WrappedComponent) {
  const ComponentWithAiTermsGate = (props) => {
    const account = useAccountAlias()
    const termsResource = useSelector(state => state.global.data.aiTermsAndConditions)

    if (!termsResource || isLoading(termsResource.status)) {
      return <Loading />
    }

    if (termsResource.data?.enabled) {
      return <WrappedComponent {...props} />
    }

    return <Navigate to={`/${account}/home`} replace />
  }

  ComponentWithAiTermsGate.displayName = `WithAiTermsGate(${WrappedComponent.displayName || WrappedComponent.name})`

  return ComponentWithAiTermsGate
}
